export default __webpack_public_path__ + "static/media/project5.2a60cde3.png";